import { render } from "./TextsFilters.vue?vue&type=template&id=1f61b9b2&scoped=true&ts=true"
import script from "./TextsFilters.vue?vue&type=script&lang=ts"
export * from "./TextsFilters.vue?vue&type=script&lang=ts"

import "./TextsFilters.vue?vue&type=style&index=0&id=1f61b9b2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f61b9b2"]])

export default __exports__